import React from 'react';
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Grid,
  Button,
} from '@mui/material';
import Add from '@mui/icons-material/Add';
import { ImageUpload } from '../../../components/atoms/UploadImage';
import {
  IService,
  OptionsServiceType,
} from '../../../utils/entities/interface';
import { getEnumValue } from '../../../utils/helper';

export const ServiceDetailsComponent = ({
  serviceDetails,
  setServiceDetails,
  mode,
}: {
  serviceDetails: IService | null;
  setServiceDetails: React.Dispatch<React.SetStateAction<IService | null>>;
  mode: 'edit' | 'add' | 'view';
}) => {
  const handleServiceNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setServiceDetails((prev) => ({
      ...(prev as IService),
      name: e.target.value,
    }));
  };

  const handleChangeCategory = (e: any) => {
    const newCategory = e.target.value;

    setServiceDetails((prevState) => {
      if (prevState) {
        return {
          ...prevState,
          category: newCategory,
        };
      } else {
        return {
          category: newCategory,
          // Provide default values for the other fields as necessary
          _id: '', // Default or placeholder value for _id
          name: '', // Default or placeholder value for name
          isActive: 1, // Default value for isActive
          createdAt: '', // Default value for createdAt
          key: '', // Default value for key
          description: [], // Default value for description
          terms: [], // Default value for terms
          banner_images: [], // Default value for banner_images
          icon: '', // Default value for icon
          updatedAt: '',
        };
      }
    });

    console.log('E', e.target.value);
  };

  const handleUploadIcon = (url: string) => {
    setServiceDetails((prev) => ({
      ...(prev as IService),
      icon: url,
    }));
  };

  const handleUploadBanner = (url: string, index: number) => {
    setServiceDetails((prev) => {
      const banners = prev?.banner_images ? [...prev.banner_images] : [];
      banners[index] = { type: `banner-${index}`, url };
      return { ...(prev as IService), banner_images: banners };
    });
  };

  const handleAddBanner = () => {
    setServiceDetails((prev) => {
      const banners = prev?.banner_images
        ? [...prev.banner_images, { type: 'banner', url: '' }]
        : [{ type: 'banner', url: '' }];
      return { ...(prev as IService), banner_images: banners };
    });
  };

  const handleRemoveBanner = (index: number) => {
    setServiceDetails((prev) => {
      const banners = prev?.banner_images ? [...prev.banner_images] : [];
      banners.splice(index, 1);
      return { ...(prev as IService), banner_images: banners };
    });
  };

  console.log('SERVICEDETAILS', serviceDetails);

  return (
    <Box sx={{ padding: 0 }}>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <TextField
            label="Service Name"
            fullWidth
            value={serviceDetails?.name || ''}
            onChange={handleServiceNameChange}
            variant="outlined"
            disabled={mode === 'view'}
            InputLabelProps={{
              shrink: true, // Force label to stay visible
            }}
          />
        </Grid>
        <Grid item>
          <TextField
            select
            label="Category"
            fullWidth
            value={serviceDetails?.category || ''} // Ensure a default empty string is used if category is undefined or null
            variant="outlined"
            disabled={mode === 'view'}
            onChange={handleChangeCategory}
          >
            {OptionsServiceType.map((option, index) => (
              <MenuItem key={index} value={option}>
                {getEnumValue(option)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item>
          <Typography variant="body1" gutterBottom>
            Service Icon
          </Typography>
          {!serviceDetails?.icon && mode === 'view' ? (
            <Box>
              <Typography
                variant="body2"
                sx={{ color: 'text.secondary', fontStyle: 'italic' }}
              >
                No Icon found
              </Typography>
            </Box>
          ) : (
            <ImageUpload
              type="icon"
              imageUrl={serviceDetails?.icon}
              uploadLabel="Service Icon(50 X 50px)"
              fileId="thumbnail-upload"
              onChange={handleUploadIcon}
              disabled={mode == 'view'}
              folderType={8}
              // onRemove={}
            />
          )}
        </Grid>

        <Grid item>
          <Typography variant="body1" gutterBottom>
            Banners
          </Typography>

          {mode === 'view' &&
          (serviceDetails?.banner_images?.length === 0 ||
            !serviceDetails?.banner_images) ? (
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', fontStyle: 'italic' }}
            >
              No banners found
            </Typography>
          ) : (
            <Grid container direction="row" spacing={1}>
              {serviceDetails?.banner_images?.map(
                (banner: any, index: number) => (
                  <Grid item key={index} xs={12} sm={12} md={12}>
                    <ImageUpload
                      imageUrl={banner.url}
                      type="banner"
                      uploadLabel="Upload Banner (370 X 140 px)"
                      fileId={`banner-upload-${index}`}
                      onChange={(url) => handleUploadBanner(url, index)}
                      onRemove={() => handleRemoveBanner(index)}
                      disabled={mode == 'view'}
                      folderType={1}
                    />
                  </Grid>
                ),
              )}
            </Grid>
          )}
        </Grid>

        {mode !== 'view' && (
          <Grid item>
            <Button startIcon={<Add />} onClick={handleAddBanner}>
              Add Banner
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
